<script lang="ts">
    import { Form, FormGroup, Input } from "sveltestrap";
    import { productDetailsData } from "../../../../Data/Ecommerce/ProductDetails/ProductDetails";
    import {searchKeyword,searchsResult} from "../../../../store"
    // for search input value
    const handleSearchKeyword = (keyword:string) => {
        searchKeyword.update(value => value = keyword );
        let array = []
        productDetailsData.filter((data)=>{
           if (data.name.toLowerCase().includes(keyword)){
            array.push(data)
           }
           searchsResult.update(value => value = [...array]);
           return data
        })
    }
</script>
<div class="product-search">
    <Form>
      <FormGroup class="m-0">
        <Input type="search" placeholder="Search.." on:input={(e)=>handleSearchKeyword(e.target.value)}/>
          <i class="fa fa-search"></i>
      </FormGroup>
    </Form>
</div>